module.exports = __webpack_public_path__ + "static/media/aph_logo.0f07f199.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aph_logo.png
// module id = 1639
// module chunks = 0